export default "__VITE_ASSET__DPhatyYB__"